import { thumbImage } from '@libs/client'
import { imagePath, moneyConverter, useCdnBasePath, videoPath } from '@ui/helpers'
import StarRating from '../shared/StarRating'

const sThumb = thumbImage('96x96')

export default function SaleItem({
  item,
  discountNumber
}: {
  item: S3Types.sales_item
  discountNumber: number
}) {
  const basepath = useCdnBasePath()
  return (
    <>
      <div className="is-hidden-mobile">
        <figure className="thumbnail">
          {(item.logo ?? '').includes('.mp4') ? (
            <video autoPlay loop muted playsInline>
              <source src={videoPath(item.logo ?? '', basepath)} type="video/mp4" />
            </video>
          ) : (
            <img
              src={sThumb(item.logo ?? '')}
              data-src={(() => {
                const image = item.logo ?? ''
                return imagePath(image)
              })()}
              alt="product sales"
              className="lazyload"
            />
          )}
        </figure>
        <div className="content">
          <div className="info">
            <StarRating rating={item.review_score} colorActive="#FFC107" colorInActive="#E0E3E9" />
            <h3 className="title">{item.title}</h3>
            <div className="info__price">
              <div className="price">
                <span className="default">${moneyConverter(item.price ?? 0)}</span>
                <span className="compared">${moneyConverter(item.compare_price ?? 0)}</span>
              </div>
              <DiscountOff discount={discountNumber} discountLabel={item?.discount_label} />
            </div>
          </div>
          <div className="view-button">
            <button className="button is-primary">
              <span>View Product</span>
            </button>
          </div>
        </div>
      </div>

      <div className="content is-hidden-tablet">
        <h3 className="sale-title">{item.title}</h3>
        <div className="info">
          <figure className="thumbnail">
            <img
              src={sThumb(item.logo ?? '')}
              data-src={(() => {
                const image = item.logo ?? ''
                return imagePath(image)
              })()}
              alt="product sales"
              className="lazyload"
            />
          </figure>
          <div className="sale-info">
            <DiscountOff discount={discountNumber} discountLabel={item?.discount_label} />
            <div className="price">
              <span className="default">${moneyConverter(item.price ?? 0)}</span>
              <span className="compared">${moneyConverter(item.compare_price ?? 0)}</span>
            </div>
            <div>
              <StarRating
                rating={item.review_score}
                colorActive="#FFC107"
                colorInActive="#E0E3E9"
              />
            </div>
          </div>
        </div>
        <button className="button ">
          <span>View Product</span>
        </button>
      </div>
    </>
  )
}

const DiscountOff = ({
  discount = 0,
  discountLabel = ''
}: {
  discount: number
  discountLabel?: string
}) => {
  return (
    <div className="discount">
      <div className="discount__number">{` ${
        discountLabel ? discountLabel : `${discount}% OFF`
      } `}</div>
    </div>
  )
}
